import { render } from "./base-allowedactions-checkbox.vue?vue&type=template&id=21acf656&ts=true"
import script from "./base-allowedactions-checkbox.vue?vue&type=script&lang=ts"
export * from "./base-allowedactions-checkbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__